m = require 'mithril'

ActionFactories = require '../../state/ActionFactories'

CommonViews 	= require '../components/CommonViews'
Breadcrumbs 	= require '../components/Breadcrumbs'
ControlBlock 	= require '../components/ControlBlock'
GameButton 		= require '../components/GameButton'

GamesPage = {
	view: (ctrl, args) ->
		games = args.games()

		CommonViews.page [
			m Breadcrumbs, {items: [{label: 'Games', icon: CommonViews.icons.home}]}
			CommonViews.pageHeading 'Games'
			if games.length > 0
				m GameButton, {game: g} for g in games
			else
				m 'p', 'No games yet.  Add below.'
			m ControlBlock, {
				content: m 'button[type=button]', {onclick: () -> m.route '/newgame'}, [
						CommonViews.icon CommonViews.icons.plus, 'button_icon'
						'Add new game'
					]
			}

			m 'hr'
			m 'p', m 'a[href="/settings"]', {config: m.route}, 'Manage settings'
		]		
}

module.exports = (store) ->
	m.component GamesPage, 	{
		games: () -> g for id,g of store.getState().gamesById
	}